export default "__VITE_ASSET__e97e202b__"